export * from './avatar/avatar.component';
export * from './list/list.component';
